module.exports = __webpack_public_path__ + "static/media/exchange.5c26306e.svg";